import React, {Component, Fragment} from 'react';
import {AsyncMarkerMap} from '../../components/common/maps/marker-map/AsyncMarkerMap';
import {getRefinements} from '../../utils/edap';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import {AllListingsButtonComponent} from '../../components/common/listings/AllListingsButton';
import {CardCarousel} from '../../components/common/carousel/Carousel';
import {ListingsRatioCard} from '../../components/common/carousel/ListingsCard';
import {SeeMorePropertiesRatioCard} from '../../components/common/carousel/SeeMorePropertiesCard';
import {isPropertyTypeAll} from '../../utils/property-types';

import {listingAsPropertyRatioCard} from './components/Listings';
import SegmentFilters from './components/SegmentFilters';
import {RetryCard} from './components/RetryCard';

import {ACTION_LOCATION, handleNext, handlePrev} from './events';
import {onFetchListingsRetry} from './redux';

import './styles.less';

export function validListing({geoCode, price}) {
    return geoCode.addressLatLngIsValid && price.shortLabel;
}

export function convertListingToMarker(listing) {
    const id = `${listing.id}-${listing.unitUuid}`;

    const position = {
        lat: listing.geoCode.latitude,
        lng: listing.geoCode.longitude,
    };

    const showExactLocation = listing.geoCode.showExactLocation;
    const key = listing.id;

    return {
        id,
        position,
        showExactLocation,
        key,
        label: listing.price.shortLabel,
    };
}

class GreatPlacesToStayComponent extends Component {
    static getDerivedStateFromError() {
        return {
            hasError: true,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    reloadComponent = () => {
        this.setState({
            hasError: false,
        });
    };

    showMap() {
        const {isMobile, showMap = true} = this.props;
        return showMap && !isMobile;
    }

    render() {
        const {
            carouselFocus,
            classNameCta,
            dispatch,
            hideGoogleMap,
            highlightedId,
            inventoryCount,
            isMobile,
            isRefined,
            lastCardUrl,
            listings = [],
            mapTitle,
            propertyType,
            segmentFilters,
            segmentKey,
            title,
            abacus,
            tripboardComponent,
            aspectRatio = '4x3',
            destinationLocation,
            showNewHeadings,
        } = this.props;

        if (listings.length === 0) {
            return null;
        }

        const markers = listings
            .filter(validListing)
            .map(convertListingToMarker);

        const types = getRefinements({
            propertyType,
            refinementKey: segmentFilters.key,
        });

        const propertyRatioCards = listings.slice(0, 6).map(
            listingAsPropertyRatioCard({
                dispatch,
                types,
                highlightedId,
                isMobile,
                tripboardComponent,
                Card: ListingsRatioCard,
                segmentKey,
            })
        );
        propertyRatioCards.push(
            <SeeMorePropertiesRatioCard
                abacus={abacus}
                key={-1}
                lastCardUrl={lastCardUrl}
            />
        );
        const listingsIdIndex = listings
            .map((listing) => listing.id)
            .indexOf(carouselFocus);

        const focusedIndex = listingsIdIndex === -1 ? null : listingsIdIndex;

        const prominentCta = (
            <AllListingsButtonComponent
                {...this.props}
                dispatch={dispatch}
                types={types}
                className={classNameCta}
                label={mapTitle}
                lastCardUrl={lastCardUrl}
            />
        );

        const refreshComponentCard = (
            <RetryCard onClickHandler={this.reloadComponent} />
        );

        const fetchRetryCard = (
            <RetryCard
                onClickHandler={onFetchListingsRetry(dispatch, segmentKey)}
            />
        );

        const map = this.state.hasError
            ? refreshComponentCard
            : this.showMap() && (
                  <div
                      className={`great-places-to-stay__map${
                          isRefined ? ' great-places-to-stay__map__refined' : ''
                      }`}
                  >
                      <Fragment>
                          {prominentCta}
                          <AsyncMarkerMap
                              dispatch={dispatch}
                              types={types}
                              segmentKey={segmentKey}
                              inventoryCount={inventoryCount}
                              clickableMarker
                              highlightedId={highlightedId}
                              markers={markers}
                              listings={listings}
                              isLoading={segmentFilters.loading}
                              hasFailed={segmentFilters.failed}
                              apiKey={'AIzaSyAFpxfcM4meoHs0Nt5BX8-bMcY7SEidAPE'}
                              channel={'vrbo-slp'}
                              fallback={fetchRetryCard}
                              destinationLocation={destinationLocation}
                          />
                      </Fragment>
                  </div>
              );

        const carouselElement = (
            <div className={'card-carousel'}>
                <CardCarousel
                    titleMessage={''}
                    focusIndex={focusedIndex}
                    aspectRatio={aspectRatio}
                    onNextClick={handleNext}
                    onPreviousClick={handlePrev}
                >
                    {propertyRatioCards}
                </CardCarousel>
            </div>
        );

        const carousel =
            isMobile && segmentFilters.failed
                ? fetchRetryCard
                : carouselElement;
        const filters = (
            <div className={'great-places-to-stay__filters'}>
                <SegmentFilters
                    overrideActive={this.state.hasError}
                    filterOverride={segmentKey}
                />
            </div>
        );

        const displayFilters = isPropertyTypeAll(propertyType) ? filters : '';

        return (
            <div
                className={
                    'container module module--no-padding great-places-to-stay'
                }
            >
                <div className={'great-places-to-stay-hd'}>
                    {showNewHeadings ? (
                        <h3 className="page-subheading">{title}</h3>
                    ) : (
                        <h2 className={'great-places-to-stay__title'}>
                            {title}
                        </h2>
                    )}
                    {displayFilters}
                    {!isRefined && !hideGoogleMap && map}
                </div>
                {carousel}
                {isRefined && !hideGoogleMap && map}
                {isMobile && prominentCta}
                <EdapViewTracker
                    eventData={{actionlocation: ACTION_LOCATION}}
                />
            </div>
        );
    }
}

export default GreatPlacesToStayComponent;
